import React from 'react'
import PropTypes from 'prop-types'

const OfferSearchDistance = ({ distance, className }) => {
  return (
    <p className={`text-16 leading-24 text-293033 flex items-center ${className}`}>
      <span className="font-semibold">{distance}</span> <span className="mx-6">|</span>
    </p>
  )
}

OfferSearchDistance.propTypes = {
  distance: PropTypes.string,
  className: PropTypes.string,
}

OfferSearchDistance.defaultProps = {
  className: '',
}

export default OfferSearchDistance
